import { isMatchDefault as e } from "./isMatchDefault.js";
//#region src/components/Tree/helpers/getSearchExpandedIds.ts
var t = (t, n, r = e) => {
	let i = /* @__PURE__ */ new Set(), a = (e) => {
		let t = (e.children ?? []).map(a).some(Boolean), o = r(e, n);
		return (t && e.children?.length || o && e.collapsible && e.helpTextElement) && i.add(e.id), o || t;
	};
	return t.forEach(a), i;
};
//#endregion
export { t as getSearchExpandedIds };
